// extracted by mini-css-extract-plugin
module.exports = {"paypalBtn":"_2qgDJu","defaultBtn":"_2OC3UH"};